import withHeader from "../../../hocs/withHeader";
import React, {useEffect, useState} from "react";

import SurveysService from "../../../../services/SurveysService";
import ActiveSurveyShare from "./ActiveSurveyShare";
import NonActiveSurveyShare from "./NonActiveSurveyShare";
import LoadingIndicator from "../../../meta/LoadingIndicator";



function SurveySharePage(props) {
    const [loadingSurveyInfo, setLoadingSurveyInfo] = useState(true);
    const [isSurveyActive, setSurveyActive] = useState(false);
    const [isProcessingActive, setIsProcessingActive] = useState(false);
    const [surveyName, setSurveyName] = useState('');
    const surveyId=props.location.pathname.split("/")[props.location.pathname.split("/").length-1];
    const shareUrl = "https://" + window.location.hostname +"/polls/"+ surveyId;

    const activationHandler = () => {
        setIsProcessingActive(true);
        SurveysService.ChangeSurveyStatus(surveyId, "ACTIVE",
            (success) => {
                setIsProcessingActive(false);
                setSurveyActive(true)
            },
            (error) => {
            setIsProcessingActive(false);
            console.log(error)
            }
        );
    };

    useEffect(()=>{
        SurveysService.getSurveyNameAndStatus(props.match.params.surveyId, (success) => {
            setSurveyName(success.data.name);
            setSurveyActive(success.data.status === "ACTIVE");
            setLoadingSurveyInfo(false);
        }, (error) =>{
            setLoadingSurveyInfo(false);
            console.log(error);
        });
    },[]);

    return (
        <React.Fragment>
            {loadingSurveyInfo ?
                (
                    <div className="questionaire__share">
                        <div className="questionaire__share__title">
                            <LoadingIndicator/>
                        </div>
                    </div>
                )
                :
                (isSurveyActive ?
                        (<ActiveSurveyShare shareUrl={shareUrl} surveyName={surveyName}></ActiveSurveyShare>)
                        :
                        (<NonActiveSurveyShare isProcessingActive={isProcessingActive} shareUrl={shareUrl}
                                               surveyName={surveyName}
                                               handlerActivateSurvey={activationHandler}></NonActiveSurveyShare>)
                )
            }
        </React.Fragment>
    );
}

export default withHeader(SurveySharePage);